const  seriesClassColor = {
    normal: ["#3574dc", "#b293ee"],
    pale: ["#86A6DC", "#F2D3FF"]
};
const  seriesBookColor = {
    normal: ["#3474dc", "#B6A2DE", "#5AB1EF", "#A1D852", "#EBD834", "#C55A11", "#2FC7C9", "#548135", "#CA0CAF"],
    pale: ["#86A6DC", "#F2D3FF", "#94E5FD", "#C1D7A0", "#C6BF80"]
};
module.exports =  {
    seriesClassColor,
    seriesBookColor,

    seriesBookChart: [
        { name: "집콕", field: "playCount1", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[0] } } },
        { name: "프리미엄동화", field: "playCount2", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[1] } } },
        { name: "기타 동화", field: "playCount3", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[2] } } },
        { name: "오디오북", field: "playCount4", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[3] } } },
        { name: "동요", field: "playCount5", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[4] } } },
        { name: "AR", field: "playCount6", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[5] } } },
        { name: "검색", field: "playCount7", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[6] } } },
        { name: "보관함", field: "playCount8", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[7] } } },
        { name: "홈", field: "playCount9", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[8] } } },
    ],
    seriesBookSumChart: [
        { name: "집콕", field: "playCountSum1", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[0] } } },
        { name: "프리미엄동화", field: "playCountSum2", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[1] } } },
        { name: "기타 동화", field: "playCountSum3", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[2] } } },
        { name: "오디오북", field: "playCountSum4", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[3] } } },
        { name: "동요", field: "playCountSum5", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[4] } } },
        { name: "AR", field: "playCountSum6", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[5] } } },
        { name: "검색", field: "playCountSum7", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[6] } } },
        { name: "보관함", field: "playCountSum8", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[7] } } },
        { name: "홈", field: "playCountSum9", stack: "base", option: { itemStyle: { color: seriesBookColor.normal[8] } } },
    ],
    seriesBookAppConnectChart: [
        { name: "앱", field: "connectApp", stack: "base", showSum: true, option: { itemStyle: { color: "#60d7c5" } } },
        { name: "웹", field: "connectWeb", stack: "base", showSum: true, option: { itemStyle: { color: "#b9ed4a" } } },
    ],
    seriesBookPlatformConnectChart: [
        { name: "Android", field: "connectAndroid", stack: "base", showSum: true, option: { itemStyle: { color: "#60d7c5" } } },
        { name: "iOS", field: "connectIos", stack: "base", showSum: true, option: { itemStyle: { color: "#b9ed4a" } } },
    ],
};